import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { CircleNotch } from '@phosphor-icons/react'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

const CatalogoMapaPage = lazy(
  () => import('@/pages/dashboard/catalogo-mapa-page'),
)

function CatalogoMapaPageFallback() {
  return (
    <div className="flex h-full min-h-0 flex-1 items-center justify-center bg-slate-50">
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <CircleNotch className="h-4 w-4 animate-spin" />
        Carregando página do mapa...
      </div>
    </div>
  )
}

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/catalogo/mapa',
)({
  component: function CatalogoMapaRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule
        anyOf={[MODULES.IMOVEIS, MODULES.EMPREENDIMENTOS]}
        dashboardId={dashboardId}
      >
        <Suspense fallback={<CatalogoMapaPageFallback />}>
          <CatalogoMapaPage dashboardId={dashboardId} />
        </Suspense>
      </RequireModule>
    )
  },
})
